<div class="sidebar" role="dialog">

	<app-sidebar-header [title]="'extrasSidebar.findHotels.title.findHotels' | ibeadmin | async">
		<div actions *ngIf="INDRA_hasChanges" ><button class="button button--small" (click)="INDRA_findHotels()" [attr.aria-label]="'extrasSidebar.findHotels.aria.confirmChanges' | ibeadmin | async">{{ 'extrasSidebar.findHotels.label.find' | ibeadmin | async }}</button></div>
	</app-sidebar-header>

	<div class="sidebar__body sl--scrollable low-contrast sidebar-wrapper" #sidebar__body>
		<form [formGroup]="form">

			<div class="form-field--row grid no-padding">

				<div class="form-field col-6 col-tp-6 col-p-6">

					<div class="hotel-input hotel-input--datepicker" [attr.aria-label]="'extrasSidebar.findHotels.aria.selectFlightDate' | ibeadmin | async"
						[ngClass]="{ 'is-active': INDRA_checkValue('checkin') }">
						<div class="overlay-click" (click)="INDRA_openMobileDatepickerModal('checkin')"
							[attr.aria-label]="'extrasSidebar.findHotels.aria.openDialogOutboundLocation' | ibeadmin | async"></div>
						<my-date-picker id="hotel-checkin" [attr.name]="'hotel-checkin'" formControlName="checkin"
							[options]="INDRA_getDatePickerOptions('checkin')" (inputFocusBlur)="INDRA_onDateChanged($event)"
							(calendarToggle)="INDRA_changeOpenDatepickerIndex($event)"></my-date-picker>
						<label>{{ 'extrasSidebar.findHotels.label.checkinDate' | ibeadmin | async }}</label>
					</div>

				</div>

				<div class="form-field col-6 col-tp-6 col-p-6">

					<div class="hotel-input hotel-input--datepicker" [attr.aria-label]="'extrasSidebar.findHotels.aria.selectFlightDate' | ibeadmin | async"
						[ngClass]="{ 'is-active': INDRA_checkValue('checkout') }">
						<div class="overlay-click" (click)="INDRA_openMobileDatepickerModal('checkout')"
						[attr.aria-label]="'extrasSidebar.findHotels.aria.openDialogOutboundLocation' | ibeadmin | async"></div>
						<my-date-picker id="hotel-checkout" [attr.name]="'hotel-checkout'" formControlName="checkout"
							[options]="INDRA_getDatePickerOptions('checkout')" (inputFocusBlur)="INDRA_onDateChanged($event)"
							(calendarToggle)="INDRA_changeOpenDatepickerIndex($event)"></my-date-picker>
						<label>{{ 'extrasSidebar.findHotels.label.checkOutDate' | ibeadmin | async }}</label>
					</div>

				</div>

				<div class="form-field col-12 col-tp-12 col-p-12">
					<app-dropdown-counter-input class="full-width" [group]="passengers" [items]="itemDropdown" ></app-dropdown-counter-input>
				</div>

			</div>


			<button  *ngIf="INDRA_hasChanges"  class="button full-width top-gap" type="submit" (click)="INDRA_findHotels()" [attr.aria-label]="'extrasSidebar.findHotels.aria.findHotels' | ibeadmin | async">
				{{ 'extrasSidebar.findHotels.label.findHotels' | ibeadmin | async }}
			</button>

		</form>

	</div>
</div>